<template>
  <q-layout id="q-app" view="lHh Lpr lFf">
    <q-layout-header>
      <q-toolbar
        color="primary"
      >
        <q-btn
          flat round dense
          icon="menu"
        >
          <q-popover>
              <q-list separator link>
                <q-item v-close-overlay @click.native="$router.push('/devices')">
                  <q-item-side icon="list" color = "primary"/>
                  <q-item-main :label="$t('devicestitle')" />
                </q-item>
                <q-item v-close-overlay @click.native="$router.push('/settings')">
                  <q-item-side icon="settings" color = "primary"/>
                  <q-item-main :label="$t('profiletitle')" />
                </q-item>
                <q-item v-close-overlay @click.native="exit">
                  <q-item-side icon="exit_to_app" color = "primary"/>
                  <q-item-main :label="$t('exit')" />
                </q-item>
              </q-list>
            </q-popover>        
        </q-btn>
        <q-toolbar-title>
          {{$t('product')}}
          <div slot="subtitle">version 2.0</div>
        </q-toolbar-title>
        <template v-if="this.$store.state.is_auth">
        <q-item to="/settings">
            <q-item-side icon="account circle" color="white"/>
            <q-item-main :label.sync="this.$store.state.name">
            </q-item-main>
        </q-item>
        </template>
        <template v-else>
        <q-item to="/auth">
            <q-item-main :label="$t('enter')" />
        </q-item>
        </template>
      </q-toolbar>
    </q-layout-header>
    <q-page-container>
      <router-view />    
    </q-page-container>
      <q-layout-footer>
          <q-toolbar>
              <q-toolbar-title>{{$t('product')}}
                  <span slot="subtitle">version 2.0</span>
              </q-toolbar-title>
                <template v-if="!this.$store.state.is_auth">              
                  <q-item to="/reg">
                      <q-item-side icon="how_to_reg" color="white" />
                      <q-item-main :label="$t('regnewuser')" />
                  </q-item>
                </template>
          </q-toolbar>
      </q-layout-footer>
  </q-layout>
</template>

<script>

export default {
  name: 'LayoutDefault',
  components: {  },
  data () {
    return {
    }
  },

  mounted()
  {
    import (`quasar-framework/i18n/${this.$store.state.lang}`).then(lang => {
      this.$q.i18n.set(lang.default)
    })
  },

  methods: {
    exit: function()
    {
        this.$q.dialog({
            title: this.$t('exit'),
            message: this.$t('exitconfirm'),
            ok: this.$t('yesbtn'),
            cancel: this.$t('nobtn')
        }).then(() => {
            this.$store.commit('unset_token')
            this.$store.commit('unset_name')                            
            this.$store.commit('unset_auth')                            
            this.$router.push('/auth')
            this.$q.notify({
                message: this.$t('exitsucc'),
                type: 'positive',
                color: 'green',
                icon: 'thumb_up'
            })

        }).catch(() => {
            
        })

    }
  }
}
</script>

<style>
</style>
